import { createContext } from 'react';

/**
 * When a step page (Model Configuration, etc.) is rendered inside the task drawer, it
 * can register a primary action for the drawer chrome (Figma).
 * @typedef {{
 *   onClick: () => void,
 *   loading?: boolean,
 *   loadingLabel?: string,
 *   label?: string,
 *   disabled?: boolean,
 *   errorMessage?: import('react').ReactNode,
 * } | null} TaskDrawerNextAction
 */
export const TaskDrawerHeaderContext = createContext(
    /** @type {null | ((action: TaskDrawerNextAction) => void)} */ (null)
);
